var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2666 4.15002V6H9.78665C8.17665 6 7.36667 6.80998 7.36667 8.41998V18H4.81668C3.38668 18 2.66666 17.28 2.66666 15.85V4.15002C2.66666 2.72002 3.38668 2 4.81668 2H9.11667C10.5467 2 11.2666 2.72002 11.2666 4.15002Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.0367 8.41998V19.58C18.0367 21.19 17.2367 22 15.6267 22H9.78665C8.17665 22 7.36667 21.19 7.36667 19.58V8.41998C7.36667 6.80998 8.17665 6 9.78665 6H15.6267C17.2367 6 18.0367 6.80998 18.0367 8.41998Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 4.15002V15.85C22.6667 17.28 21.9466 18 20.5166 18H18.0367V8.41998C18.0367 6.80998 17.2367 6 15.6267 6H14.0667V4.15002C14.0667 2.72002 14.7866 2 16.2166 2H20.5166C21.9466 2 22.6667 2.72002 22.6667 4.15002Z",
    fill: "#2D2D2D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 11.75H10.6667C10.2567 11.75 9.91666 11.41 9.91666 11C9.91666 10.59 10.2567 10.25 10.6667 10.25H14.6667C15.0767 10.25 15.4167 10.59 15.4167 11C15.4167 11.41 15.0767 11.75 14.6667 11.75Z",
    fill: "#2D2D2D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 14.75H10.6667C10.2567 14.75 9.91666 14.41 9.91666 14C9.91666 13.59 10.2567 13.25 10.6667 13.25H14.6667C15.0767 13.25 15.4167 13.59 15.4167 14C15.4167 14.41 15.0767 14.75 14.6667 14.75Z",
    fill: "#2D2D2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 19V22H11.9167V19C11.9167 18.59 12.2567 18.25 12.6667 18.25C13.0767 18.25 13.4167 18.59 13.4167 19Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildings);
export default __webpack_public_path__ + "static/media/buildings.834dace405abd6bcbe5f51645d6b5d17.svg";
export { ForwardRef as ReactComponent };